import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Slider from "react-slick";
import apiInstance from "../../../utility/apiInstance";

const ForgortPassword = () => {

    const route = all_routes;
    const [email, setEmail] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [submitted, setSubmitted] = useState<boolean>(false);

    const validateEmail = (val: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(val.trim());
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (!email.trim()) {
            setEmailError("Email address is required.");
            return;
        }
        if (!validateEmail(email)) {
            setEmailError("Please enter a valid email address.");
            return;
        }
        setEmailError("");
        setSubmitting(true);
        try {
            await apiInstance.post("/api/custom/forgot-password", {
                email: email.trim(),
            });
        } catch {
            // Payload's forgot-password endpoint responds with success
            // regardless of whether the email exists, to avoid leaking
            // which addresses are registered.
        } finally {
            setSubmitting(false);
            setSubmitted(true);
        }
      };
    const loginSLider = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        // autoplay: true, // Uncomment if needed
      };

  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper">
        <div className="login-content">
          <div className="row">
            {/* Login Banner */}
            <div className="col-md-6 login-bg d-none d-lg-flex">
              <Slider {...loginSLider} className="login-carousel">
                <div>
                  <div className="login-carousel-section mb-3">
                    <div className="login-banner">
                      <ImageWithBasePath
                        src="assets/img/auth/auth-1.svg"
                        className="img-fluid"
                        alt="Logo"
                      />
                    </div>
                    <div className="mentor-course text-center">
                      <h3 className="mb-2">
                        Forgot Your <br />
                        Password?
                      </h3>
                      <p>
                        No worries — it happens. Enter your email and we'll
                        send you a link to reset it.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="login-carousel-section mb-3">
                    <div className="login-banner">
                      <ImageWithBasePath
                        src="assets/img/index-3/banner-01.png"
                        className="img-fluid"
                        alt="Logo"
                      />
                    </div>
                    <div className="mentor-course text-center">
                      <h3 className="mb-2">
                        Get Back to <br />
                        Learning
                      </h3>
                      <p>
                        Reset your password in just a few clicks and pick up
                        right where you left off.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="login-carousel-section mb-3">
                    <div className="login-banner">
                      <ImageWithBasePath
                        src="assets/img/index-3/register-img.png"
                        className="img-fluid"
                        alt="Logo"
                      />
                    </div>
                    <div className="mentor-course text-center">
                      <h3 className="mb-2">
                        We've Got <br />
                        Your Back
                      </h3>
                      <p>
                        Our team is here to help if you run into any trouble
                        accessing your account.
                      </p>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
            {/* /Login Banner */}
            <div className="col-md-6 login-wrap-bg">
              {/* Login */}
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="w-100">
                    <div className="d-flex align-items-center justify-content-between login-header">
                      <ImageWithBasePath
                        src="assets/img/logo-white.png"
                        className="img-fluid"
                        alt="Logo"
                      />
                      <Link to={route.homesix} className="link-1">
                        Back to Home
                      </Link>
                    </div>
                    <div className="topic">
                      <h1 className="fs-32 fw-bold mb-3">Forgot Password</h1>
                      <p className="fs-14 fw-normal mb-0">
                        {submitted
                          ? "Check your inbox for a link to reset your password."
                          : "Enter your email to reset your password."}
                      </p>
                    </div>
                    {submitted ? (
                      <div className="mb-3 pb-3">
                        <div className="alert alert-success fs-14" role="alert">
                          If an account exists for <strong>{email.trim()}</strong>,
                          we&apos;ve sent a password reset link to it. The link
                          expires in 1 hour.
                        </div>
                      </div>
                    ) : (
                      <form onSubmit={handleSubmit} className="mb-3 pb-3">
                        <div className="mb-3 position-relative">
                          <label className="form-label">
                            Email<span className="text-danger ms-1">*</span>
                          </label>
                          <div className="position-relative">
                            <input
                              type="text"
                              className={`form-control form-control-lg ${emailError ? "is-invalid" : ""}`}
                              value={email}
                              onChange={(e) => {
                                setEmail(e.target.value);
                                if (emailError) setEmailError("");
                              }}
                            />
                            <span>
                              <i className="isax isax-sms input-icon text-gray-7 fs-14" />
                            </span>
                          </div>
                          {emailError && (
                            <div className="text-danger fs-14 mt-1">
                              {emailError}
                            </div>
                          )}
                        </div>
                        <div className="d-grid">
                          <button
                            className="btn btn-secondary btn-lg"
                            type="submit"
                            disabled={submitting}
                          >
                            {submitting ? "Submitting..." : "Submit"}
                            <i className="isax isax-arrow-right-3 ms-1" />
                          </button>
                        </div>
                      </form>
                    )}
                    <p className="fs-14 fw-normal d-flex align-items-center justify-content-center">
                      Remember Password?
                      <Link to={route.login} className="link-2 ms-1">
                        {" "}
                        Sign In
                      </Link>
                    </p>
                    {/* /Login */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default ForgortPassword;
